//is Mobile
!function(a){var b=/iPhone/i,c=/iPod/i,d=/iPad/i,e=/(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,f=/Android/i,g=/(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,h=/(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,i=/Windows Phone/i,j=/(?=.*\bWindows\b)(?=.*\bARM\b)/i,k=/BlackBerry/i,l=/BB10/i,m=/Opera Mini/i,n=/(CriOS|Chrome)(?=.*\bMobile\b)/i,o=/(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,p=new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)","i"),q=function(a,b){return a.test(b)},r=function(a){var r=a||navigator.userAgent,s=r.split("[FBAN");if("undefined"!=typeof s[1]&&(r=s[0]),s=r.split("Twitter"),"undefined"!=typeof s[1]&&(r=s[0]),this.apple={phone:q(b,r),ipod:q(c,r),tablet:!q(b,r)&&q(d,r),device:q(b,r)||q(c,r)||q(d,r)},this.amazon={phone:q(g,r),tablet:!q(g,r)&&q(h,r),device:q(g,r)||q(h,r)},this.android={phone:q(g,r)||q(e,r),tablet:!q(g,r)&&!q(e,r)&&(q(h,r)||q(f,r)),device:q(g,r)||q(h,r)||q(e,r)||q(f,r)},this.windows={phone:q(i,r),tablet:q(j,r),device:q(i,r)||q(j,r)},this.other={blackberry:q(k,r),blackberry10:q(l,r),opera:q(m,r),firefox:q(o,r),chrome:q(n,r),device:q(k,r)||q(l,r)||q(m,r)||q(o,r)||q(n,r)},this.seven_inch=q(p,r),this.any=this.apple.device||this.android.device||this.windows.device||this.other.device||this.seven_inch,this.phone=this.apple.phone||this.android.phone||this.windows.phone,this.tablet=this.apple.tablet||this.android.tablet||this.windows.tablet,"undefined"==typeof window)return this},s=function(){var a=new r;return a.Class=r,a};"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=r:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?module.exports=s():"function"==typeof define&&define.amd?define("isMobile",[],a.isMobile=s()):a.isMobile=s()}(this);

var isLow = false;
var $html, $window;
var DEVICE_RATIO = window.devicePixelRatio;
var windowWidth = 0,
direction = 'forward',
windowHeight = 0,
windowWidthHalf = 0,
windowHeightHalf = 0,
windowTop = 0;


var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// ForIE
if ('NodeList' in window && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}


/*
 █████╗ ███╗   ██╗██╗███╗   ███╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗
██╔══██╗████╗  ██║██║████╗ ████║██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║
███████║██╔██╗ ██║██║██╔████╔██║███████║   ██║   ██║██║   ██║██╔██╗ ██║
██╔══██║██║╚██╗██║██║██║╚██╔╝██║██╔══██║   ██║   ██║██║   ██║██║╚██╗██║
██║  ██║██║ ╚████║██║██║ ╚═╝ ██║██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║
╚═╝  ╚═╝╚═╝  ╚═══╝╚═╝╚═╝     ╚═╝╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝
*/

var anim = {

	io : {
		d : 0.01,
	},

	popup : {
		y : 80,
		skewY : 10,
		in : {
			s : 0.6,
			e : Power2.easeOut,
			d : 0.04,
		},
		out : {
			s : 0.6,
			e : Power2.easeInOut,
		}
	},

	tr : {
		in : {
			s : 0.55,
			e : Power1.easeInOut,
		},
		out : {
			s : 0.5,
			e : Power1.easeInOut,
		}
	},
};


$(function(){
	$html = $('html');
	windowWidth  = window.innerWidth;
	windowHeight = window.innerHeight;
	windowWidthHalf  = windowWidth/2;
	windowHeightHalf = windowHeight/2;

	// UA判定
	var userAgent = window.navigator.userAgent;
	var browserIE = false;
	var browser_nm;

	//IE判定
	if(userAgent.match(/MSIE/) || userAgent.match(/Trident/)) {
		browserIE = true;
	}
	if (browserIE) {
		// IE
		isLow = true;
		$html.addClass('is-ie is-low is-loaded');
	}else if (userAgent.indexOf("Edge") > -1) {
		// EDGE
		isLow = true;
		$html.addClass('is-edge is-low');
	}else if (userAgent.indexOf("Firefox") > -1) {
		// FireFox
		$html.addClass('is-ff is-high');
	}else if (userAgent.indexOf("Chrome") > -1) {
		// Chrome
		$html.addClass('is-chrome is-high');
	}else if (userAgent.indexOf("Opera") > -1) {
		// Opera
		$html.addClass('is-opera is-high');
	}else if(userAgent.indexOf("Safari") > -1) {
		// Safari
		$html.addClass('is-safari is-high');
	}else {
		// Other
		$html.addClass('is-other is-high');
	}

	//OS判定
	if (navigator.platform.indexOf("Win") != -1) {
		$html.addClass('is-win');
	}
	if(isMobile.any){
		$html.addClass('is-mobile');
	}else{
		$html.addClass('is-pc');
	}

	// INIT BEFORE
	// 整形前
	
	page.init();
	words.init();
	page.onResize();
	// slider.init();

	$(window).on({
		scroll : function(){
			windowTop = $(this).scrollTop();
			pageScroll.onScroll();
		},
		resize : function(){
			page.onResize();
			// slider.onResize();
		},
	});
	splash.onStart();
	modal.init();
});



/*
██╗    ██╗ ██████╗ ██████╗ ██████╗ ███████╗
██║    ██║██╔═══██╗██╔══██╗██╔══██╗██╔════╝
██║ █╗ ██║██║   ██║██████╔╝██║  ██║███████╗
██║███╗██║██║   ██║██╔══██╗██║  ██║╚════██║
╚███╔███╔╝╚██████╔╝██║  ██║██████╔╝███████║
 ╚══╝╚══╝  ╚═════╝ ╚═╝  ╚═╝╚═════╝ ╚══════╝
*/


var words = {
	init : function(){
		// Sprit Char
		var chars = document.querySelectorAll('.js-char');
		for (var i = 0; i < chars.length; i++) {
			if( !chars[i].classList.contains('char') ){
				chars[i].classList.add('char')
				var text = chars[i].innerHTML;
				var html = '';
				text.split(' ').forEach(function (w) {
					html += '<span class="w-o">';
					if( w === '&amp;' ){
						// 指定した特殊記号の場合
						html += '<span class="o"><span class="c">'+w+'</span></span>';
					} else {
						w.split('').forEach(function (c) {
							html += '<span class="o"><span class="c">'+c+'</span></span>';
						});
					}
					html += '</span>';
				});
				chars[i].innerHTML = html;
			}
		}
		// Sprit Words
		var chars = document.querySelectorAll('.js-words');
		for (var i = 0; i < chars.length; i++) {
			if( !chars[i].classList.contains('char') ){
				chars[i].classList.add('char')
				var text = chars[i].innerHTML;
				var html = '';
				text.split(' ').forEach(function (w) {
					html += '<span class="w-o"><span class="o"><span class="c">'+w+'</span></span></span>';
				});
				chars[i].innerHTML = html;
			}
		}
	},
	onShow : function(){
		$('.js-b-show').each( function( index, el ){
			var $el = $(el);
			$el.find('.o').each(function( i, e ){
				var delay = i * 0.03 + index * 0.3;
				TweenLite.to(e, 0.6, {
					y       : '0%',
					opacity : 1,
					delay   : delay,
					ease    : Power2.easeOut
				});
			});
		});
		$('.js-w-show').each( function( index, el ){
			var $el = $(el);
			$el.find('.o').each(function( i, e ){
				var delay = i * 0.03 + index * 0.3;
				TweenLite.to(e, 0.6, {
					y       : '0%',
					opacity : 1,
					delay   : delay,
					ease    : Power2.easeOut
				});
			});
		});
	}
}


/*
███████╗██████╗ ██╗      █████╗ ███████╗██╗  ██╗
██╔════╝██╔══██╗██║     ██╔══██╗██╔════╝██║  ██║
███████╗██████╔╝██║     ███████║███████╗███████║
╚════██║██╔═══╝ ██║     ██╔══██║╚════██║██╔══██║
███████║██║     ███████╗██║  ██║███████║██║  ██║
╚══════╝╚═╝     ╚══════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝
*/


var splash = {
	onStart : function(){
		var _this = this;
		
		TweenLite.to( '.PageLoading' , 1.2, {
			opacity:0,
			ease : Power2.easeOut,
			onComplete : function(){
				$html.addClass('is-loaded');
			}
		});

		setTimeout(function() {
			_this.onFire();
		}, 100);
	},
	onFire : function(){
		var _this = this;
		words.onShow();
		page.onShow();
		pageScroll.onScroll();

		var userAgent = window.navigator.userAgent;
		if(userAgent.match(/MSIE/) || userAgent.match(/Trident/)) {
			$('.io,.io-o').addClass('on');
		}else{
			pageScroll.initIO();
		}

		var url = $(location).attr('href');
		if (url.indexOf("?id=") == -1) {
		}else{
			var url_sp = url.split("?id=");
			var hash = '#' + url_sp[url_sp.length - 1];
			var tgt = $(hash);
			var pos = tgt.offset().top - 150;
			if(userAgent.match(/MSIE/) || userAgent.match(/Trident/)) {
				$(window).animate({scrollTop:pos});
			}else {
				TweenLite.to( $(window), 0.6, {scrollTo:{ y: pos, autoKill: false }});
			}
		}
	},
}



/*
██████╗  █████╗  ██████╗ ███████╗
██╔══██╗██╔══██╗██╔════╝ ██╔════╝
██████╔╝███████║██║  ███╗█████╗  
██╔═══╝ ██╔══██║██║   ██║██╔══╝  
██║     ██║  ██║╚██████╔╝███████╗
╚═╝     ╚═╝  ╚═╝ ╚═════╝ ╚══════╝
*/
var page = {

	init : function(){
		if( $('body').is('.template-index') ){
			$('body').addClass('header-transparent');
		}else{
			$('.header-goast').height($('store-header').height());
		}
	},

	onResize : function(){
		windowWidth  = window.innerWidth;
		windowHeight = window.innerHeight;
		windowWidthHalf  = windowWidth/2;
		windowHeightHalf = windowHeight/2;
		$('.js-window-h').height(windowHeight);
		$('.js-window-w').width(windowWidth);
	},

	onShow : function(){
		$('.js-show').each( function( index, el ){
			var delay = index * 0.1;
			TweenLite.to(el, 1, {
				y       : '0',
				opacity : 1,
				delay   : delay,
				ease    : Power2.easeOut
			});
		});
	}
}

